// n.b. this needs to be a CommonJS module in order to work in Node.js

const tailwindScreens = require('../../tailwind.screens');
const { STATE_CLASSES } = require('../data/constants/classes');

const deviceClasses = {
    des: STATE_CLASSES.DESKTOP,
    lap: STATE_CLASSES.LAPTOP,
    tab: STATE_CLASSES.TABLET,
    mob: STATE_CLASSES.MOBILE,
};

class Device {
    constructor(data = {}) {
        this.name = data.name || '';
        this.deviceClass = data.deviceClass || '';
        this.displayName = data.displayName || '';
        this.icon = data.icon || '';
        this.min = data.min || '';
        this.max = data.max || '';
        this.deviceWidth = data.deviceWidth || '';
        this.deviceHeight = data.deviceHeight || '';
        this.deviceContentWidth = data.deviceContentWidth || '';
        this.deviceContentHeight = data.deviceContentHeight || '';
        this.deviceImage = data.deviceImage || '';
    }
}

function getDevices() {
    const devices = [
        new Device({
            name: 'all',
            deviceClass: deviceClasses.des,
            displayName: 'desktop',
            icon: 'desktop',
            min: tailwindScreens.des.min,
            deviceWidth: '',
            deviceHeight: '',
            deviceContentWidth: '',
            deviceContentHeight: '',
            deviceImage: '',
        }),

        new Device({
            name: 'lap',
            deviceClass: deviceClasses.lap,
            displayName: 'laptop',
            icon: 'laptop',
            min: tailwindScreens.lap.min,
            max: tailwindScreens.lap.max,
            deviceWidth: '1200px',
            deviceHeight: '100%',
            deviceContentWidth: '100%',
            deviceContentHeight: '100%',
            deviceImage: '',
        }),

        new Device({
            name: 'tab',
            deviceClass: deviceClasses.tab,
            displayName: 'tablet',
            icon: 'tablet',
            min: tailwindScreens.tab.min,
            max: tailwindScreens.tab.max,
            deviceWidth: '667px',
            deviceHeight: '948px',
            deviceContentWidth: '575px',
            deviceContentHeight: '775px',
            deviceImage: 'tablet.png',
        }),

        new Device({
            name: 'mob',
            deviceClass: deviceClasses.mob,
            displayName: 'mobile',
            icon: 'mobile',
            max: tailwindScreens.mob.max,
            deviceWidth: '414px',
            deviceHeight: '836px',
            deviceContentWidth: '354px',
            deviceContentHeight: '628px',
            deviceImage: 'phone.png',
        }),
    ];

    return devices;
}

module.exports = {
    deviceClasses,
    getDevices,
};
